import { render, staticRenderFns } from "./InstagramModal.vue?vue&type=template&id=5f61bef9&scoped=true&"
import script from "./InstagramModal.vue?vue&type=script&lang=js&"
export * from "./InstagramModal.vue?vue&type=script&lang=js&"
import style0 from "./InstagramModal.vue?vue&type=style&index=0&id=5f61bef9&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f61bef9",
  null
  
)

export default component.exports